var _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgEmail = function SvgEmail(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.0664 4.26562H2.93359C1.8696 4.26562 1 5.1314 1 6.19922V17.8008C1 18.869 1.87016 19.7344 2.93359 19.7344H21.0664C22.1304 19.7344 23 18.8686 23 17.8008V6.19922C23 5.13114 22.13 4.26562 21.0664 4.26562ZM20.7695 5.55469C20.1443 6.1819 12.8012 13.549 12.4995 13.8517C12.2475 14.1044 11.7526 14.1046 11.5005 13.8517L3.23051 5.55469H20.7695ZM2.28906 17.5638V6.43619L7.83482 12L2.28906 17.5638ZM3.23051 18.4453L8.74486 12.913L10.5876 14.7617C11.3427 15.5193 12.6576 15.519 13.4125 14.7617L15.2552 12.913L20.7695 18.4453H3.23051ZM21.7109 17.5638L16.1652 12L21.7109 6.43619V17.5638Z",
    fill: "url(#paint0_linear_1065_18519)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1065_18519",
    x1: 23.4125,
    y1: 15.4805,
    x2: 9.31728,
    y2: 0.679083,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3559FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#36B2FA"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgEmail);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/email.02e364870f894dfb8dab78b640587889.svg";